import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

class LabelShipCol extends React.PureComponent {

    render() {
        const {multiLabel, hasLabel, labelDetails} = this.props

        const { partnerTrackingNumber, url, 'created': track_created } = Object.assign({}, labelDetails)

        const timeGenTracking = track_created ? new Date(track_created).toLocaleString('en-GB') : '';

        return (
            <div className="notDisableCancel Labels">
                {
                    multiLabel && hasLabel && partnerTrackingNumber &&
                    <React.Fragment>
                        <a href={url} target='_blank' rel="noopener noreferrer">{partnerTrackingNumber}</a>&nbsp;
                        <Tooltip title="Tracking Status">
                            <a href={`https://webtrack.dhlglobalmail.com/?trackingnumber=${partnerTrackingNumber}`}
                            target='_blank' rel="noopener noreferrer"><i className='icon-new-tab' /></a>
                        </Tooltip>

                        <br /><span>{timeGenTracking}</span>
                    </React.Fragment>
                }
            </div>
        );
    }
}

LabelShipCol.propTypes = {
    hasLabel: PropTypes.bool.isRequired,
    multiLabel: PropTypes.bool.isRequired,
    labelDetails: PropTypes.object,
};

export default LabelShipCol;
